import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import './AddUser.css';
import AddUserForm from './components/AddUserForm';
import IState from '../../core/models/IState';
import * as actions from '../../core/actions/actions';
import { reset } from 'redux-form';
import { formatMessage } from '../../translations/connectedIntlProvider';
interface Props {
  id: number;
  modalClosed: () => void;
}

const AddUser = (props: any) => {
  useEffect(() => {
    if (props.id > 0) {
      props.getUserById(props.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.addUserState.success) {
      if (props.id === -1)
        toast.success(formatMessage("Message_User_Add_Success"));
      else
        toast.success(formatMessage("Message_User_Update_Success"));
      props.resetAddUserState();
      props.resetGetUserByIdState();
      props.resetAddUserForm();
      props.modalClosed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.addUserState.success]);

  useEffect(() => {
    if (props.addUserState.error != null)
      toast.error(formatMessage(props.addUserState.error));
  }, [props.addUserState.error]);

  const onSubmitForm = (values: any) => {
    props.addUser(props.id, values);
  }

  const onModalClosed = () => {
    props.resetAddUserState();
    props.resetGetUserByIdState();
    props.resetAddUserForm();
    props.modalClosed();
  }


  return (
    <React.Fragment>
      <AddUserForm
        id={props.id}
        isDelete={props.isDelete}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        getUserLoading={props.user.loading}
        addUserLoading={props.addUserState.loading}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state: IState) => ({
  addUserState: state.user.addUser,
  user: state.user.user,

});

const mapDispatchToProps = (dispatch: any) => {
  return {
    resetAddUserState: () => dispatch(actions.resetAddUserState()),
    addUser: (id: number, data: any) => dispatch(actions.addUser(id, data)),
    resetGetUserByIdState: () => dispatch(actions.resetGetUserByIdState()),
    getUserById: (data: any) => dispatch(actions.getUserById(data)),
    resetAddUserForm: () => dispatch(reset('AddUserForm')),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
